import { useMemo } from 'react';
import { useApi } from '@/api/useApi';
import { useQueryProvider } from '@/hooks';
import { QUERY_KEYS } from '@/constants/QueryKeys';
import { BOUTIQUE_STUDENTS_QUERY_SCOPE, EXPERT_STUDENTS_FIRST_PAGE, EXPERT_STUDENTS_PAGE_SIZE } from '../boutique-classroom.constants';
import { mapStudentStatistic } from '../boutique-classroom.mappers';
import { BoutiqueStudent } from '../students/boutique-students.types';

interface UseExpertStudentsParams {
	page?: number;
	size?: number;
	searchQuery?: string;
	withoutGroup?: boolean;
	enabled?: boolean;
}

const EMPTY_STUDENTS: BoutiqueStudent[] = [];
const BOUTIQUE_ONLY = true;

export function useExpertStudents({ page = EXPERT_STUDENTS_FIRST_PAGE, size = EXPERT_STUDENTS_PAGE_SIZE, searchQuery, withoutGroup = false, enabled = true }: UseExpertStudentsParams = {}) {
	const { StudentStatisticControllerApi } = useApi();

	const { data, isLoading, isFetching, refetch } = useQueryProvider(
		[QUERY_KEYS.findStudentDetailedStatisticsOfLoggedInExpert, BOUTIQUE_STUDENTS_QUERY_SCOPE, page, size, searchQuery ?? '', withoutGroup],
		() =>
			StudentStatisticControllerApi.findStudentDetailedStatisticsOfLoggedInExpert(
				undefined,
				undefined,
				undefined,
				undefined,
				undefined,
				searchQuery || undefined,
				undefined,
				undefined,
				BOUTIQUE_ONLY,
				withoutGroup || undefined,
				page,
				size
			),
		{
			select: ({ data: response }) => response?.data,
			refetchOnWindowFocus: false,
			keepPreviousData: true,
			enabled
		}
	);

	const students = useMemo<BoutiqueStudent[]>(() => (data?.content ?? []).map(mapStudentStatistic).filter((student): student is BoutiqueStudent => student !== null), [data]);

	return {
		students: students.length ? students : EMPTY_STUDENTS,
		totalElements: data?.totalElements ?? 0,
		totalPages: data?.totalPages ?? 0,
		isLoading,
		isFetching,
		refetch
	};
}
